<template>
  <div class="channel-flow-space-y-4">
    <p class="channel-flow-description">
      {{ getTranslations("expression_1395") }}
    </p>
    <div class="channel-flow-space-y-2 text-center">
      <button @click="handleActivateAndLaunch" class="channel-flow-btn-primary" :disabled="isLoading">
        {{ isLoading ? getTranslations("expression_1401") : getTranslations("expression_1400") }}
      </button>

    </div>

    <!-- Iframe Modal -->
    <div v-if="showIframe" class="iframe-overlay" @click="closeIframe">
      <div class="iframe-container" @click.stop>
        <button @click="closeIframe" class="iframe-close-btn">&times;</button>
        <iframe :src="iframeUrl" class="whatsapp-iframe" frameborder="0">
        </iframe>
      </div>
    </div>
  </div>
</template>


<script>
import { api } from "../../../services/index";
import "../../../../js/assets/css/Channel-Flow/channel-flow.css"
export default {
  props: {
    selectedChannel: {
      type: Object,
      required: true,
    },
    companyInfo: {
      type: Object,
      required: true,
    },
    userList: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      isLoading: false,
      showIframe: false,
      iframeUrl: '',
      websocket: null,
    };
  },
  methods: {
    async handleActivateAndLaunch() {
      const channel_id = await this.activateChannel();

      if (channel_id) {
        this.launchWhatsAppSignup(channel_id);
      }
    },

    async activateChannel() {
      this.isLoading = true;

      const integrationKeyMap = {
        0: 15, // WhatsApp Comum
        1: 12, // WhatsApp Oficial
        2: 13, // Instagram
        3: 14, // Messenger
      };

      const payload = {
        company: {
          name: this.companyInfo.name,
          address: {
            zip_code: null,
            country: null,
            district: null,
            city: null,
            state: null,
            number: null,
            street: null,
          },
        },
        type_key: this.selectedChannel.type_key,
        integration_key: integrationKeyMap[this.selectedChannel.type_key] || null,
        departments: this.companyInfo.teams.map((team, index) => ({
          name: team.name,
          position: index,
          id: null,
        })),
        users: this.userList,
      };

      try {
        const response = await api.post("/channels/flow-new-channel", payload);

        if (response.status === 201 && response.data?.id) {
          this.$toast.success(this.getTranslations("expression_1396"));
          return response.data.id; // ← RETORNA O ID

        } else {
          this.$toast.error(this.getTranslations("expression_1397"));
          return null;
        }


      } catch (error) {
        console.error(this.getTranslations("expression_1398"), error);

        if (error.response && error.response.data && error.response.data.message) {
          this.$toast.error(`Erro: ${error.response.data.message}`);
        } else {
          this.$toast.error(this.getTranslations("expression_1399"));
        }

      } finally {
        this.isLoading = false;
      }
    },
    launchWhatsAppSignup(channel_id) {
      const url_deploy = document.URL.split('/')[2]
      
      const jwt_token = window.localStorage.getItem("access_token")
      const url_sdk_whatsapp = `https://embedded.faeldev.com/?provider=instagram&apiKey=21212131231231&webhookUrl=${url_deploy}&channel_id=${channel_id}&token=${jwt_token}`;

      this.iframeUrl = url_sdk_whatsapp;
      this.showIframe = true;
      console.log("URL do SDK do WhatsApp:", url_sdk_whatsapp);
      // Conectar ao WebSocket
      this.connectWebSocket(url_deploy);
    },
    closeIframe() {
      this.showIframe = false;
      this.iframeUrl = '';
      
      // Desconectar WebSocket
      if (this.websocket) {
        this.websocket.close();
        this.websocket = null;
      }
    },
    connectWebSocket(url_deploy) {
      try {
        // Substitua pela URL real do seu WebSocket
        this.websocket = new WebSocket('wss://your-websocket-url.com');
        
        this.websocket.onopen = () => {
          console.log('WebSocket conectado');
        };
        
        this.websocket.onmessage = (event) => {
          try {
            const data = JSON.parse(event.data);
            const eventType = data.type || data.event;
            
            if (eventType === `channel_created#${url_deploy}`) {
              this.handleChannelCreated(data);
            } else if (eventType === `channel_created_failed#${url_deploy}`) {
              this.handleChannelCreatedFailed(data);
            }
          } catch (error) {
            console.error('Erro ao processar mensagem WebSocket:', error);
          }
        };
        
        this.websocket.onerror = (error) => {
          console.error('Erro no WebSocket:', error);
        };
        
        this.websocket.onclose = () => {
          console.log('WebSocket desconectado');
        };
        
      } catch (error) {
        console.error('Erro ao conectar WebSocket:', error);
      }
    },
    handleChannelCreated(data) {
      console.log('Canal criado com sucesso:', data);
      
      // Ações para quando o canal for criado com sucesso
      this.$toast.success('Canal criado com sucesso!');
      this.closeIframe();
      this.$emit("finished");
    },
    handleChannelCreatedFailed(data) {
      console.log('Falha ao criar canal:', data);
      
      // Ações para quando falhar ao criar o canal
      const errorMessage = data.message || 'Erro ao criar canal';
      this.$toast.error(`Falha ao criar canal: ${errorMessage}`);
    },
  }
  ,
  beforeDestroy() {
    // Garantir que o WebSocket seja fechado ao destruir o componente
    if (this.websocket) {
      this.websocket.close();
    }
  }
};
</script>

<style scoped>
.iframe-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.iframe-container {
  position: relative;
  width: 50%;
  height: 70%;
  max-width: 1200px;
  max-height: 800px;
  background: white;
  border-radius: 8px;
  overflow: hidden;
}

.iframe-close-btn {
  position: absolute;
  top: 10px;
  right: 15px;
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  z-index: 1001;
  color: #666;
}

.iframe-close-btn:hover {
  color: #000;
}

.whatsapp-iframe {
  width: 100%;
  height: 100%;
}
</style>


